import { ButtonHTMLAttributes, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import VisuallyHidden from '@components/UI/utilities/VisuallyHidden';

type PasswordVisibility = {
  visible: boolean;
  toggleProps: Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'onClick' | 'aria-label' | 'aria-pressed'>;
  announcement: ReactElement;
};

const usePasswordVisibility = (): PasswordVisibility => {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState<boolean>(false);

  const announcement = visible ? t('Password is visible') : t('Password is hidden');

  return {
    visible,
    toggleProps: {
      type: 'button',
      onClick: () => setVisible((prev) => !prev),
      'aria-label': t('Show password'),
      'aria-pressed': visible
    },
    announcement: <VisuallyHidden role="status">{announcement}</VisuallyHidden>
  };
};

export default usePasswordVisibility;
